import { call, put, select, take } from "redux-saga/effects";
import { subscriptionPreferencesAT } from "../../subscriptionPreferences/SubscriptionPreferencesModel";
import { IState } from "../../../../../common/state/IState";
import { umSpPageAuthSelector } from "../../_shared/selectors";
import { fetchSaga} from "../_services/apiCalls";
import { showErrorOnSubscriptionPreferencesAction } from "../../subscriptionPreferences/subscriptionPreferencesActions";
import { ngdUserManagementConfig } from "../_services/endpoints";

export function* loadSchemeSaga() {
    let action;
    while ((action = yield take([subscriptionPreferencesAT.hasUser]))) {
        yield call(loadScheme, action);
    }
}

const selector = (s: IState) => umSpPageAuthSelector(s)?.token;

function* loadScheme(action) {
    let token, objectName;

    if (action.type == subscriptionPreferencesAT.hasUser) {
        token = action.authInfo.token;
        objectName = action.authInfo.userRecordInfo.objectName;
    } else {
        token = yield select(selector);
        objectName = action.objectName;
    }

    const [isSuccess, scheme] = yield call(
        fetchSaga,
        ngdUserManagementConfig.apiUrl +
            `v1/Profile/object/${objectName}/scheme`,
        {
            credentials: "omit",
            headers: {
                Authorization: "Bearer " + token,
            },
        }
    );

    if (!isSuccess) {
        yield put(
            showErrorOnSubscriptionPreferencesAction(
                "internal error: no scheme: " + scheme.message,
                true
            )
        );
    } else {
        yield put({ type: subscriptionPreferencesAT.hasScheme, scheme });
    }
}
